import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconUpload = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 25"
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M21 15.5v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8.5l-5-5-5 5M12 3.5v12"
        ></path>
      </svg>
    </SvgWrapper>
  );
};

export default IconUpload;
